document.addEventListener('DOMContentLoaded', function() {
  const headerWrapperEl = document.querySelector(".header-wrapper");
  const homeHero = document.querySelector("main > .section-image-banner");
  
  if (headerWrapperEl && homeHero) {
    function checkScroll() {
      const headerHeight = headerWrapperEl.offsetHeight;
      const heroHeight = homeHero.offsetHeight;
      
      const scrollThreshold = heroHeight - headerHeight;
      const scrollPosition = window.scrollY;
      
      if (scrollPosition >= scrollThreshold) {
        headerWrapperEl.classList.add("scrolled");
      } else {
        headerWrapperEl.classList.remove("scrolled");
      }
    }
    
    checkScroll();
    window.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
  }
});